import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/696c72981beda80014863fe1_1785165748822_9def65d3/go_speed_academy/src/app/not-found.tsx");
